import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const MatchMapVetoContext = createContext<{
  params?: Routing.MatchMapVetoParams
}>({})

export { MatchMapVetoContext }
